// Module
var code = "<svg v-else width=\"8\" height=\"2\" viewBox=\"0 0 8 2\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <rect width=\"8\" height=\"1.5\" rx=\"0.75\" fill=\"white\"/> </svg>";
// Exports
module.exports = code;